function normalizeStripePublishableKey(value) {
	if (!value) {
		return '';
	}

	return value.toString().trim();
}

function isLiveStripePublishableKey(value) {
	return /^pk_live_/.test(normalizeStripePublishableKey(value));
}

function isTestStripePublishableKey(value) {
	return /^pk_test_/.test(normalizeStripePublishableKey(value));
}

function resolveStripePublishableKey(options) {
	var nodeEnv = options && options.nodeEnv ? options.nodeEnv.toString().trim().toLowerCase() : '';
	var injectedPublishableKey = normalizeStripePublishableKey(options && options.injectedPublishableKey);
	var rolloutPublishableKey = normalizeStripePublishableKey(options && options.rolloutPublishableKey);
	var productionFallbackKey = normalizeStripePublishableKey(options && options.productionFallbackKey);
	var isProduction = nodeEnv === 'production';

	if (isProduction) {
		// Never return a test key in production — pick the first non-test key.
		var productionCandidates = [rolloutPublishableKey, injectedPublishableKey, productionFallbackKey];
		for (var i = 0; i < productionCandidates.length; i++) {
			var candidate = productionCandidates[i];
			if (candidate && !isTestStripePublishableKey(candidate)) {
				return candidate;
			}
		}
		return '';
	}

	if (injectedPublishableKey) {
		return isLiveStripePublishableKey(injectedPublishableKey) ? '' : injectedPublishableKey;
	}

	if (rolloutPublishableKey) {
		return isLiveStripePublishableKey(rolloutPublishableKey) ? '' : rolloutPublishableKey;
	}

	return '';
}

// --- Pricing catalog fetch (centralized plan + add-on metadata) -----------
// The authoritative pricing catalog lives behind /api/v1/billing/plans on the
// Node server. This module exposes a small in-memory cache so that settings
// popups (change plan, hour pack, workspace upgrade) share a single fetch and
// stay consistent with Stripe. Returns the full { plans, addOns } shape. On
// any failure (network, missing endpoint, etc.) returns null so callers can
// fall back to their hardcoded defaults.

var PRICING_CATALOG_CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

var _pricingCatalogCache = {
	timestamp: 0,
	data: null,
	inFlight: null
};

function _invalidatePricingCatalogCache() {
	_pricingCatalogCache = { timestamp: 0, data: null, inFlight: null };
}

function fetchPricingCatalog(options) {
	var opts = options || {};
	var forceRefresh = opts.forceRefresh === true;
	var now = Date.now();

	if (!forceRefresh && _pricingCatalogCache.data && (now - _pricingCatalogCache.timestamp) < PRICING_CATALOG_CACHE_TTL_MS) {
		return Promise.resolve(_pricingCatalogCache.data);
	}

	if (_pricingCatalogCache.inFlight) {
		return _pricingCatalogCache.inFlight;
	}

	// Resolve the public API via getInstance() so we don't call private methods.
	// Lazy-require to avoid circular import concerns.
	var apiModule;
	try {
		// This file lives at assets/www/js/models/helper/StripeConfig.js.
		// Sibling helper TrebbleClientAPI.js is registered under the webpack
		// alias "models/helper/TrebbleClientAPI" elsewhere in the codebase.
		apiModule = require('models/helper/TrebbleClientAPI');
	} catch (err) {
		console.warn('fetchPricingCatalog: unable to load TrebbleClientAPI module', err);
		return Promise.resolve(null);
	}

	var apiDefault = apiModule && apiModule.default ? apiModule.default : apiModule;
	if (!apiDefault || typeof apiDefault.getInstance !== 'function') {
		return Promise.resolve(null);
	}

	var apiInstance;
	try {
		apiInstance = apiDefault.getInstance();
	} catch (err) {
		console.warn('fetchPricingCatalog: TrebbleClientAPI.getInstance() threw', err);
		return Promise.resolve(null);
	}

	if (!apiInstance || typeof apiInstance.getBillingPlans !== 'function') {
		return Promise.resolve(null);
	}

	var inFlight = Promise.resolve()
		.then(function () {
			return apiInstance.getBillingPlans();
		})
		.then(function (response) {
			var payload = null;
			if (response && typeof response === 'object') {
				if (Array.isArray(response.plans)) {
					payload = { plans: response.plans, addOns: response.addOns || {} };
				} else if (response.data && Array.isArray(response.data.plans)) {
					payload = { plans: response.data.plans, addOns: response.data.addOns || {} };
				}
			}
			if (payload) {
				_pricingCatalogCache.timestamp = Date.now();
				_pricingCatalogCache.data = payload;
			}
			_pricingCatalogCache.inFlight = null;
			return payload;
		})
		.catch(function (err) {
			console.warn('fetchPricingCatalog: backend fetch failed, falling back to null', err);
			_pricingCatalogCache.inFlight = null;
			return null;
		});

	_pricingCatalogCache.inFlight = inFlight;
	return inFlight;
}

module.exports = {
	normalizeStripePublishableKey: normalizeStripePublishableKey,
	isLiveStripePublishableKey: isLiveStripePublishableKey,
	isTestStripePublishableKey: isTestStripePublishableKey,
	resolveStripePublishableKey: resolveStripePublishableKey,
	fetchPricingCatalog: fetchPricingCatalog,
	_invalidatePricingCatalogCache: _invalidatePricingCatalogCache
};
module.exports.default = module.exports;
